import { render } from "./MRadio.vue?vue&type=template&id=f920208a"
import script from "./MRadio.vue?vue&type=script&lang=js"
export * from "./MRadio.vue?vue&type=script&lang=js"

import "./MRadio.vue?vue&type=style&index=0&id=f920208a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__